import { useState, useEffect } from "react"
import { fetchToken } from "../../Auth"
import axios from "axios"
import { useNavigate } from "react-router-dom"

const SciativeMedia = () => {
  const [newsData, setNewsData] = useState([])
  const [newsImages, setNewsImages] = useState({})
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  const getNews = async () => {
    try {
      const response = await axios.get(`/backend/get_news/1`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${fetchToken("nuprice_access_token")}`,
        },
      })
      // Only take the first 3 news items
      setNewsData(response.data.slice(0, 3))
    } catch (err) {
      console.error("Error", err)
      if (err.response?.status === 401) {
        navigate("/login")
      } else if (err.response?.status === 400) {
        navigate("/error")
      }
    } finally {
      setLoading(false)
    }
  }

  // Function to fetch news image
  const fetchNewsImage = async (itemId) => {
    try {
      // Find the news item to get its image type
      const newsItem = newsData.find((item) => item.id === itemId)
      const imgId = `img-${itemId}`

      // Get the file extension from the image type
      let fileExtension = "jpg" // Default extension
      if (newsItem && newsItem[imgId]?.type) {
        const imageType = newsItem[imgId].type
        if (imageType === "image/jpeg" || imageType === "image/jpg") {
          fileExtension = "jpeg"
        } else if (imageType === "image/png") {
          fileExtension = "png"
        } else if (imageType === "image/gif") {
          fileExtension = "gif"
        }
      }
      const imageID = `news-${itemId.toString()}-${imgId}.${fileExtension}`

      // Updated URL format to include the file extension
      const response = await axios.get(`/backend/get_news_image/${imageID}`, {
        headers: {
          Authorization: `Bearer ${fetchToken("nuprice_access_token")}`,
        },
      })

      // Store the image URL in state
      setNewsImages((prev) => ({
        ...prev,
        [itemId]: response.data,
      }))

      return response.data // This should be the presigned URL
    } catch (error) {
      console.error(`Error fetching image for news item ${itemId}:`, error)
    }
  }

  // Load news data on component mount
  useEffect(() => {
    getNews()
  }, [])

  // Fetch images when news data changes
  useEffect(() => {
    if (newsData.length > 0) {
      // Fetch images for all news items
      newsData.forEach((item) => {
        fetchNewsImage(item.id)
      })
    }
  }, [newsData])

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return ""

    // Parse the date string
    const date = new Date(dateString)

    // Array of month names
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ]

    // Get day, month name, and year
    const day = date.getDate()
    const month = months[date.getMonth()]
    const year = date.getFullYear()

    // Return formatted date
    return `${day} ${month} ${year}`
  }

  return (
    <section className="sciative_media">
      <div className="container" data-aos="new-animation">
        <h2 className="bigHead text-center mb-5">Sciative in Media</h2>

        {loading ? (
          <div className="text-center">Loading news...</div>
        ) : newsData.length === 0 ? (
          <div className="text-center">No news items available</div>
        ) : (
          newsData.map((item, index) => (
            <div className="row media_row g-0" key={item.id}>
              <div className="col-md-7">
                <p className="media_head">
                  <span>Article</span> {formatDate(item.publishDate)}
                </p>
                <h3 className="article_head">
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    {item.title}
                  </a>
                </h3>
                <p className="article_author">{item.author}</p>
              </div>
              <div className="col-md-3 offset-md-2">
                <a
                  href={item.url.startsWith("www") ? `//${item.url}` : item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={newsImages[item.id]} alt={item.title} />
                </a>
              </div>
            </div>
          ))
        )}
      </div>
      <div className="text-center">
        <a href="/news">
          <button className="black-button text-center mt-5">
            Load More <span className="material-symbols-outlined">chevron_right</span>
          </button>
        </a>
      </div>
    </section>
  )
}

export default SciativeMedia
